import React from "react";

export const JackpotValue = item => {
    if (item.jackpotPlus > 0) return <span className="jackpot-value left-bet-type-THREE">+{item.jackpotPlus}</span>
    return <b>{item.isJackpot ? (
        <span className="jackpot-value left-bet-type-THREE">x{item.jackpot}</span>) : "---"}</b>;
}

export const Jackpot = (props) => {
    const {t, item, className} = props;
    if (item.jackpotPlus > 0) {
        return <span className="jackpot-value"> +{item.jackpotPlus}</span>
    }
    if (item.isJackpot)
        return <span
            className="jackpot-value">{t("labels:drawing.jp." + item.jackpotType)} x{item.jackpot}</span>

    return <span className={className}>---</span>;
}
